// Use the reference storefront's Swiper version and section configuration.
window.SolveraCarousel = window.Swiper;
document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('#Details-menu-drawer-container');
  drawer?.addEventListener('toggle', () => {
    drawer.classList.toggle('menu-opening',drawer.open);
    drawer.querySelector('summary')?.setAttribute('aria-expanded',drawer.open?'true':'false');
  });
  document.querySelectorAll('.search-modal__close-button').forEach(button=>button.addEventListener('click',()=>button.closest('details')?.removeAttribute('open')));
  document.addEventListener('keydown',event=>{
    if(event.key==='Escape') document.querySelectorAll('header details[open]').forEach(details=>details.removeAttribute('open'));
  });
});
